import React, { useState } from "react";
import { FiX, FiCheck } from "react-icons/fi";
import { IoCalendarOutline } from "react-icons/io5";
import XmlDropzone from "../components/XmlDropzone";

/**
 * Modal "Novo relatório semanal" — aberto pelo quadrado pontilhado da
 * faixa de períodos. Contém a dropzone de XMLs da semana; confirmar gera
 * o demonstrativo (mock).
 */
export default function NovaSemanaModal({ isOpen, onClose, semanaNumero, range, onGerar }) {
  const [aceitos, setAceitos] = useState([]);

  if (!isOpen) return null;

  const gerar = () => {
    onGerar(aceitos);
    setAceitos([]);
    onClose();
  };

  return (
    <div className="lanc-modal-overlay" onClick={onClose}>
      <div className="lanc-modal novo-rel-modal" onClick={(e) => e.stopPropagation()}>
        <div className="lanc-modal-head">
          <h3>
            <IoCalendarOutline style={{ color: "#10b981", marginRight: 8 }} />
            Novo relatório semanal · Semana {semanaNumero}
            {range ? <span style={{ opacity: 0.5, fontWeight: 500 }}> · {range}</span> : null}
          </h3>
          <button type="button" className="close" onClick={onClose}><FiX /></button>
        </div>

        <div className="lanc-modal-body">
          <XmlDropzone
            titulo={`Arraste os XMLs da Semana ${semanaNumero} aqui`}
            hint="ou clique para selecionar · notas de saída, devolução e entrada com crédito"
            onFilesChange={setAceitos}
          />
        </div>

        <div className="lanc-modal-foot">
          <button type="button" className="btn-ghost" onClick={onClose}>Cancelar</button>
          <button
            type="button"
            className="btn-primary"
            onClick={gerar}
            disabled={aceitos.length === 0}
          >
            <FiCheck /> Gerar Semana {semanaNumero}{aceitos.length > 0 ? ` (${aceitos.length} XMLs)` : ""}
          </button>
        </div>
      </div>
    </div>
  );
}
